
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisSarVesselIec as ObiAisSarVesselIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-sar-vessel-iec.js';
 
 
 

 
 export const ObiAisSarVesselIec = createComponent({
   react: React,
   tagName: 'obi-ais-sar-vessel-iec',
   elementClass: ObiAisSarVesselIecElement,
   events: {
     
   }
  });
 
 